import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isMobileMenuOpen: false,
  isSidebarOpen: false,
  screenWidth: typeof window !== "undefined" ? window.innerWidth : 0,
};

const mobilemenuSlice = createSlice({
  name: "mobilemenu",
  initialState,
  reducers: {
    toggleMobileMenu: (state) => {
      state.isMobileMenuOpen = !state.isMobileMenuOpen;
    },
    openSidebar: (state) => {
      state.isSidebarOpen = true;
    },
    closeSidebar: (state) => {
      state.isSidebarOpen = false;
    },
    setScreenWidth: (state, action) => {
      state.screenWidth = action.payload;
    },
  },
});

export const { toggleMobileMenu, openSidebar, closeSidebar, setScreenWidth } =
  mobilemenuSlice.actions;

export default mobilemenuSlice.reducer;
